module.exports = __webpack_public_path__ + "media/stone_4.526ce02f.webm";